<template>
    <div class="filters">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Liste des fournisseurs</h3>
            </div>
            <el-form ref="filtersForm" :model="filters" label-position="top">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4 mb-4">
                            <a class="btn btn-outline-primary " href="/infos/manufacturers-list.csv">
                                Télécharger la liste des fournisseurs
                            </a>
                        </div>

                        <div class="col-md-4 mb-4">
                            <a class="btn btn-outline-primary " href="/helper-files/available-features-import.xlsx">
                                Télécharger la liste des features disponibles à l'import
                            </a>
                        </div>

                        <div class="col-md-4 mb-4">
                            <a class="btn btn-outline-primary " href="/helper-files/available-categories-import.xlsx">
                                Télécharger la liste des catégories disponibles à l'import
                            </a>
                        </div>
                        <div class="col-md-4 mb-4">
                            <a class="btn btn-outline-primary " href="/helper-files/brands-manufacturers.xlsx">
                                Télécharger la liste des Marques -> Fournisseurs
                            </a>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="pull-left">

                    </div>
                    <div class="pull-right">
                        <el-button @click="resetFilters" type="info" plain>Annuler</el-button>
                        <el-button @click="validFilters" type="primary">Valider</el-button>
                    </div>
                </div>
            </el-form>
        </div>



    </div>
</template>
<script>
import { EventBus } from '../../event-bus';

export default {
    data() {
        return {
            brandsOptions: [],
            categoriesOptions: [],
            manufacturersOptions: [],
            filters: {
                brand_id: '',
                manufacturer_id: '',
                category_id: [],
                queryAutocomplete: null,
                product_search: null,
            },
            groupedActionsOptions: [],
            groupedActionsValue: '',
            rules: {},
            modal: {}
        };
    },
    props: {
        selected: {
            default() {
                return [];
            }
        }
    },
    computed: {
        q: {
            get() {
                return this.$store.getters['app/q'];
            },
            set(value) {
                this.$store.dispatch('app/setQ', value);
            }
        },
        total_item() {
            return this.$store.getters['categories/totalItems'];
        },
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        applyToAllResult: {
            get() {
                return this.$store.getters['categories/applyToAllResults'];
            },
            set(value) {
                this.$store.dispatch('categories/setApplyToAllResults', value);
            }
        }
    },
    mounted() {
        EventBus.$on('search-input.submit', () => {
            this.validFilters();
        });
    },
    methods: {

        resetFilters() {
            this.$refs.filtersForm.resetFields();
            this.$store.dispatch('app/setQ', null);
            this.validFilters();
        },

        validFilters() {
            var filters = {};
            this.filters.q = this.q;
            var exclude = ['applyToAllResult'];
            for (let filter in this.filters) {
                if (
                    this.filters[filter] != '' &&
                    this.filters[filter] !== null &&
                    exclude.indexOf(filter) == -1
                ) {
                    filters[filter] = this.filters[filter];
                }
            }
            this.$emit('update-filters', filters);
        },
        setFilter(filter_name, value, noValidate) {
            this.filters[filter_name] = value;
            if (!noValidate) {
                this.validFilters();
            }
        },
        applyAction(v) {
            if (!this.selected.length && !this.applyToAllResult) return;
            switch (v) {
                default:
                    break;
            }
        },
    }
};
</script>
<style lang="scss">
.el-form {
    .card-footer {
        text-align: initial;
        .pull-right {
            text-align: center;
        }
    }
}
</style>
